<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'票据红冲账单'"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="selects_s(1)">查询</el-button>
        <el-button @click="update(2)">全部添加</el-button>
        <el-button @click="order_excel">导出</el-button>
        <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item label="票据查询">
                <el-input size="mini" v-model="date.xsc_bill_no" clearable placeholder="票据号码"></el-input>
              </el-descriptions-item>
              <el-descriptions-item  label="">
              </el-descriptions-item>
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="47vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="order_id" label="账单ID" width="80"></el-table-column>
            <el-table-column prop="customer" label="姓名" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chargeitem_name" label="收费项目" width="130"></el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="数量" width="80"></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="charge_paid" label="收款金额" width="80"></el-table-column>
            <el-table-column prop="dis_count" label="减免金额" width="80"></el-table-column>
            <el-table-column prop="delay_dis_count" label="减免违约金" width="100"></el-table-column>
            <el-table-column prop="state_name" label="状态" width="60"></el-table-column>
            <el-table-column prop="meter_order_house_id" label="账单读数" width="100">
              <template slot-scope="scope">
                {{scope.row.meter_order_house_id > 0 ? '有' : '无'}}
              </template>
            </el-table-column>
            <el-table-column prop="payment" label="支付方式" width="109"></el-table-column>
            <el-table-column prop="operator_date" label="缴款时间" width="150"></el-table-column>
            <el-table-column prop="xsc_bill_no" label="票据号码" width="150"></el-table-column>
            <el-table-column prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column prop="log_name" label="操作人" width="100"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <!-- <Page :total="total" :page-size="page" @on-change="selects" show-total /> -->
        <el-pagination @size-change="selects"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[20,50,100,200,300,400,500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          total:0,
          page:1,
          type:1,
          pageSize:20,
          loading_dade:1,
          dialogVisible:false,
          tableData: [],
          order: [],
          money_val:0,
          money:0,
          date:{
            date_s:'',
            date_e:'',
            startDate:'',
            endDate:'',
            type:'模糊查询',
            paid_type:"1",
            has_reading:"0",
            xsc_bill_no:'',
          },
          select:{
            pay:'',
            // house:'',
            // name:'',
            // date:'',
            // chargeitem_id:[],
          },
          customer:[],
          dataPay:[],
          xsc_bill_no:'',
          house:[],
          chargeitem:[],
          loading:false,
          pid:'',
          house_name:'',
        }
      },
      mounted(){

      },
      //事件
      methods: {
        //返回数据
        getInvo(house,pid){
          this.dialogVisible = true;
          this.pid = pid;
          this.house = house;
          this.page = 1;

        },
        // 添加
        update(e){
          this.message = '';
          this.$confirm('确定操作吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let data = {'select':this.select,'pid':this.pid,'type':e,'order':this.order,'date':this.date};
            this.$myhttp.post('admin/OrderBillRedFlushFlow/add',data,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$confirm('操作失败：'+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                }else{
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                  this.dialogVisible = false;
                  //调用父组件方法
                  this.$parent.selects(1);
                }
            },err=>{
              this.loading = false;
              this.$Message.error('请求异常!');
            });
          })
        },
        selects_s(page = 0) {
          if (this.date.xsc_bill_no == '') {
            this.$confirm('请输入票据号', '提示', {
              confirmButtonText: '关闭',
              cancelButtonText: '取消',
              type: 'warning'
            })
            return false;
          }

          if (page) {
            this.page = 1;
          }
          this.money = "加载中";
          this.total = 1;
          if(this.type != 1){
            this.page = 1;
          }
          this.type = 1;//账单非日志
          this.selects(this.pageSize);
          let data = {'select':this.select,'date':this.date,'type':1,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          //分页
          this.$myhttp.post('admin/OrderList/paid_count',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.total = backdata.data.count;
          },err=>{
            this.$Message.error('请求异常!');
          });
          //金额
          this.$myhttp.post('admin/OrderList/paid_money',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.money = backdata.data.money;
          },err=>{
            this.$Message.error('请求异常!');
          });
        },
        // 查询
        selects(e){
          if(e){
            this.pageSize = e;//1页多少条
          }
          this.loading_dade = 2;
          let data = {'select':this.select,'date':this.date,'type':this.type,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          this.$myhttp.post('admin/OrderList/paid',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.tableData = backdata.data.data;
              this.loading_dade = 1;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        //导出
        order_excel(){
          this.loading_dade = 2;
          let data = {'select':this.select,'date':this.date,'type':this.type,'page':this.page,'pid':this.pid,'pageSize':this.pageSize}
          this.$myhttp.post('admin/OrderBillRedFlushFlow/excel',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              if(backdata.data.code==200){
                var url = this.$myhttp.defaults.baseURL+"/"+backdata.data.data;
                window.open(url, '_blank');
              }else{
                this.$confirm('提示：'+backdata.data.message, '提示', {
                  confirmButtonText: '关闭',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                //this.$Message.error(backdata.data.message);
              }
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        handleCurrentChange(e){
          this.page = e;//第几页
          this.selects(this.pageSize);
        },
        handleClose(done) {
          done();
        },
        handleSelectionChange(val) {
          this.order = val;
          let money = 0;
          this.order.map(req=>{
              money = Number(money) + Number(req.charge_paid);
          })
          this.money_val = money.toFixed(2);
        },
        //远程搜索
        remoteMethod(query){
          if (query !== '') {
            this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query)+'&pid='+this.pid,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.house = backdata.data.data;
            });
          }
        },
        //更换项目id
        houses(e){
          if(e){
            this.house.map(req=>{
              if(req.house == e){
                this.pid = req.erp_pindex_id;
              }
            })
          }
          this.housePid();
        },
        //查询当前项目
        housePid(){
          this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+encodeURIComponent(this.select.house),{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 200){
                this.house_name = backdata.data.data.name;
                this.pid = backdata.data.data.id;
              }
          });
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/selectBillRedFlush.vue